import { makeStyles } from '@material-ui/core/styles'
import { Grid, Tooltip, Typography, Zoom } from '@mui/material'
import Info from 'src/assets/CdBalance_Images/Info.svg'
import CdAccountEmployeeStatisticsTooltip from 'src/components/ceo/CDBalance/CdAccountEmployeeStatisticTooltip'
import { formatDateString } from 'src/utils/commonMethods/formatDate'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { COLORS } from 'src/utils/Themes/colors'

const CdAccountLinkedPoliciesView = ({ policyData }) => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.subContent}>
        <div className={classes.heading}>
          <div>
            <img
              src={
                policyData?.provider?.image
                  ? policyData?.provider?.image
                  : '---'
              }
            />
          </div>
          <div>
            <span className={classes.headingText}>
              {policyData?.insuranceType ? policyData?.insuranceType : '---'}
            </span>
            <br></br>
            <span className={classes.headingSubText}>
              {policyData?.productSubType ?? '---'}
            </span>
          </div>
        </div>
        <div className={classes.policyContent}>
          <Grid container className={classes.policyContainer}>
            <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
              <div className={classes.item}>
                <Typography className={classes.accountTextHeading}>
                  Policy Number:
                </Typography>
                <span className={classes.accountText}>
                  {policyData?.policyNumber ? policyData?.policyNumber : '---'}
                </span>
              </div>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
              <div className={classes.item}>
                <Typography className={classes.accountTextHeading}>
                  Premium Amount:
                </Typography>
                <span className={classes.accountText}>
                  {formatToINR(policyData?.premiumAmount?.text)}
                </span>
              </div>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={3} xl={3}>
              <div className={classes.item}>
                <div>
                  <span className={classes.accountTextHeading}>
                    Start Date:{' '}
                  </span>
                  <span className={classes.accountText}>
                    {formatDateString(policyData?.issuedOn)
                      ? formatDateString(policyData?.issuedOn)
                      : '---'}
                  </span>
                </div>
                <div>
                  <span className={classes.accountTextHeading}>End Date: </span>
                  <span className={classes.accountText}>
                    {formatDateString(policyData?.expiresOn)
                      ? formatDateString(policyData?.expiresOn)
                      : '---'}
                  </span>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={3}
              xl={3}
              className={classes.infoContent}
            >
              <div className={classes.infoText}>
                <div>
                  <span className={classes.accountTextHeading}>
                    No of Employees:{' '}
                  </span>
                  <span className={classes.accountText}>
                    {policyData?.totalNoOfEmployees
                      ? policyData?.totalNoOfEmployees
                      : '---'}
                  </span>
                </div>
                <div>
                  <Tooltip
                    TransitionComponent={Zoom}
                    placement='bottom'
                    title={
                      <CdAccountEmployeeStatisticsTooltip data={policyData} />
                    }
                    className={classes.tooltipContainer}
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: `${COLORS.WHITE} !important`,
                          boxShadow: ' 10px 10px 30px  rgba(0, 0, 0, 0.7)',
                          borderRadius: '10px',
                        },
                      },
                      arrow: {
                        sx: {
                          color: `${COLORS.WHITE} !important`,
                        },
                      },
                    }}
                  >
                    <img src={Info} className={classes.info} />
                  </Tooltip>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
}

export default CdAccountLinkedPoliciesView
const useStyles = makeStyles({
  heading: {
    display: 'flex',
    gap: '20px',
    padding: '20px',
    alignItems: 'center',
  },
  headingText: {
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '21px',
    fontFamily: 'Roboto',
    color: '#B92250',
  },
  policyContainer: {
    textAlign: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  subContent: {
    border: '1px solid #B92250',
    margin: '25px',
    borderRadius: '10px',
    boxShadow: '4px 4px 16px -10px',
  },
  policyContent: {
    background: '#F1EAED',
    borderRadius: '0px 0px 10px 10px',
  },
  accountTextHeading: {
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '21px',
    fontFamily: 'Roboto',
  },
  accountText: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '21px',
    fontFamily: 'Roboto',
  },
  info: {
    width: '16px',
  },
  infoContent: {
    display: 'flex',
    justifyContent: 'center',
  },
  infoText: {
    display: 'flex',
    gap: '10px',
    padding: '10px',
  },
  item: {
    padding: '10px',
  },
  tooltipContainer: {
    background: '#FFF !important',
    width: '100% !important',
  },
  headingSubText: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '21px',
    fontFamily: 'Roboto',
    textOverflow: 'ellipsis !important',
  },
})
